import React, { useState, useEffect, FC, ChangeEvent } from 'react';
import {BatteryLow, BatteryMedium, BatteryFull } from 'lucide-react';

interface BatteryAlarmProps {
  alarm: {
    type: string;
    name: string;
    group: string;
    batteryThreshold: number;
  };
  onChange: (updatedAlarm: BatteryAlarmProps['alarm']) => void;
}

const BatteryAlarm: FC<BatteryAlarmProps> = ({ alarm, onChange }) => {
  const [threshold, setThreshold] = useState<number>(alarm.batteryThreshold);

  useEffect(() => {
    setThreshold(alarm.batteryThreshold);
  }, [alarm.batteryThreshold]);

  const handleThresholdChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = Number(event.target.value);
    setThreshold(value);
    onChange({ ...alarm, batteryThreshold: value });
  };

  const getBatteryColor = (value: number) => {
    if (value < 20) return 'red';
    if (value < 50) return 'orange';
    return 'green';
  };

  const getBatteryIcon = (value: number) => {
    if (value < 20) return <BatteryLow color={getBatteryColor(value)} size={18} />;
    if (value < 80) return <BatteryMedium color={getBatteryColor(value)} size={18} />;
    return <BatteryFull color={getBatteryColor(value)} size={18} />;
  };

  return (
    <div style={{ maxWidth: '300px', marginTop: '10px' }}>
      <label htmlFor="batteryThreshold" style={{ fontWeight: 'bold' }}>
        Battery Level:
      </label>

      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
        {getBatteryIcon(threshold)}
        <span style={{ fontSize: '0.9em' }}>Low</span>
        <input
          type="range"
          id="batteryThreshold"
          min={0}
          max={100}
          value={threshold}
          onChange={handleThresholdChange}
          style={{
            width: '140px', // correspond à la largeur du champ texte
            height: '6px',
            borderRadius: '5px',
            accentColor: getBatteryColor(threshold)
          }}
        />
        <span style={{ fontSize: '0.9em' }}>Full</span>
      </div>

      <div style={{ fontSize: '0.9em', color: getBatteryColor(threshold) }}>
        Selected level: <strong>{threshold}%</strong>
      </div>
    </div>
  );
};

export default BatteryAlarm;
